import WIDGETS from './widgets';

export default {
	name: 'lukas_invite_func_form',
	spacing: 2,
	widgets: [
		{ content: WIDGETS.INVITE_FUNC_FORM, breakpoints: { xs: 12 }, lazy_loading: 0, component_props: { config_form: 'lukas_invite_form_config' } },
	],
};
